
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"74","height":"75","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M62.233 22.775h-18.49l-4.468 9.014a.6.6 0 00.154.614l7.164 5.008a.486.486 0 01.079.692l-8.24 9.094a.468.468 0 000 .614l4.622 5.007a.48.48 0 01.079.54l-7.865 11.785a.48.48 0 01-.85-.374L36.5 54.282a.576.576 0 00-.153-.464l-6.393-6.067a.584.584 0 01-.075-.618l5.468-8.475a.414.414 0 00-.154-.614l-7.55-5.008a.547.547 0 01-.228-.46l2.247-9.861H11.929A5.934 5.934 0 006 28.65v39.264a5.932 5.932 0 005.928 5.932h50.148a5.932 5.932 0 005.932-5.932V28.65c.154-3.18-2.543-5.876-5.775-5.876z","fill":"#413E3E"}}),_c('path',{attrs:{"d":"M37.116 14.378a2.926 2.926 0 002.929-2.925V3.671a2.928 2.928 0 00-5.854 0v7.782a2.921 2.921 0 002.925 2.925zM47.515 16.292c.318.126.66.178 1 .154a2.997 2.997 0 002.776-1.93L53.986 7.2a2.948 2.948 0 10-5.547-2l-2.696 7.348a2.883 2.883 0 001.771 3.745zM23.024 14.457a2.895 2.895 0 002.775 1.925 4.405 4.405 0 001-.154 2.944 2.944 0 001.772-3.775l-2.697-7.318a2.949 2.949 0 00-5.546 2.004l2.696 7.318z","fill":"#1BBAC8"}})])
          )
        }
      }
    